module.exports = __webpack_public_path__ + "img/m-banner.749fd24a.png";